import React, { useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Users, Briefcase, FileText } from "react-feather";
import TableComponent from "../../components/widgets/table/index";
import { useQuery } from "react-query";
import { ModalContext } from 'context/ModalContext';
import AddProductUnderwriter from 'components/widgets/modals/AddProductUnderwriter';
import { fetchConfiguredUnderwriters, list_intermediary_underwriters } from 'services/apiSrv';

function Underwriter() {
    const history = useHistory();
    const { setModalShow, modalShow, modalClose } = useContext(ModalContext);


    const get_underwriters = async () => {
        let resp = await list_intermediary_underwriters();
        console.log("resp underwriters---", resp);
        return resp.data._value || [];
    };

    const {
        data: underwriters,
        isLoading,
        isError,
        error,
        isFetching,
        refetch
    } = useQuery({
        queryKey: ["underwriters"],
        queryFn: get_underwriters,
        staleTime: 5 * 60 * 1000,
        retry: 3,
    });

    console.log("UUUNDERWRIT---", underwriters)

    if (isLoading || isFetching) {
        return <div>Loading underwriters...</div>;
    }

    if (isError) {
        return <div>Error: {error.message}</div>;
    }

    // Ensure underwriters is an array; fallback to empty array if undefined
    const underwriterData = Array.isArray(underwriters) ? underwriters : [];

    const tableFields = [
        { name: "System Reference" },
        { name: "Name" },
        { name: "Email" },
        { name: "Settlement Type" },
        { name: "Status" },
        { name: "Created Date" },
        { name: "Action" },
    ];

    const tableRowData = [
        { type: "text", field: "underwriterSystemRef" },
        { type: "text", field: "name" },
        { type: "text", field: "email" },
        { type: "text", field: "settlementType" },
        { type: "status", field: "status" },
        { type: "date", field: "createdDate" },
        {
            type: "action",
            field: "id",
            actions: [
                {
                    method: (id) => {
                        console.log(`Navigating to view underwriter ${id}`);
                        history.push(`/dashboard/viewUnderwriter/${id}`);
                    },
                    field: "id",
                    title: "View",
                },
            ],
        },
    ];

    // Calculate summary metrics
    const activeCount = underwriterData.filter((uw) => uw.status === "active").length;
    const inactiveCount = underwriterData.filter((uw) => uw.status === "inactive").length;
    const totalPremium = underwriterData.reduce((sum, uw) => sum + (uw.totalPremium || 0), 0);
    const settledPremium = underwriterData.reduce((sum, uw) => sum + (uw.settledPremium || 0), 0);
    const pendingPremium = underwriterData.reduce((sum, uw) => sum + (uw.pendingPremium || 0), 0);
    const totalCommission = underwriterData.reduce((sum, uw) => sum + (uw.totalCommission || 0), 0);

    return (
        <div className="c#ard p-4" >
            <div className="mb-4">
                <Row>
                    <Col md={3}>
                        <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e7eb" }}>
                            <Card.Body className="d-flex align-items-center">
                                <Users size={40} className="text-primary mr-3" />
                                <div>
                                    <Card.Title style={{ fontSize: "1.2rem", fontWeight: "600" }}>Total Underwriters</Card.Title>
                                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>{underwriterData.length}</Card.Text>
                                    <Card.Text style={{ fontSize: "1rem", color: "#6b7280" }}>
                                        Active: {activeCount}
                                    </Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e7eb" }}>
                            <Card.Body className="d-flex align-items-center">
                                <Briefcase size={40} className="text-success mr-3" />
                                <div>
                                    <Card.Title style={{ fontSize: "1.2rem", fontWeight: "600" }}>Total Premium</Card.Title>
                                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>KES {totalPremium.toLocaleString()}</Card.Text>
                                    <Card.Text style={{ fontSize: "1rem", color: "#6b7280" }}>
                                        Settled: KES {settledPremium.toLocaleString()}
                                    </Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e7eb" }}>
                            <Card.Body className="d-flex align-items-center">
                                <Briefcase size={40} className="text-warning mr-3" />
                                <div>
                                    <Card.Title style={{ fontSize: "1.2rem", fontWeight: "600" }}>Commission</Card.Title>
                                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>KES {totalCommission.toLocaleString()}</Card.Text>
                                    <Card.Text style={{ fontSize: "1rem", color: "#6b7280" }}>
                                        Total earnings
                                    </Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e7eb" }}>
                            <Card.Body className="d-flex align-items-center">
                                <FileText size={40} className="text-info mr-3" />
                                <div>
                                    <Card.Title style={{ fontSize: "1.2rem", fontWeight: "600" }}>Pending Premium</Card.Title>
                                    <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>KES {pendingPremium.toLocaleString()}</Card.Text>
                                    <Card.Text style={{ fontSize: "1rem", color: "#6b7280" }}>
                                        Outstanding
                                    </Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <div style={
        { borderRadius: "12PX", background: "#ffffff",   padding:"2rem", marginTop: "26px"}
      }>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0">Underwriter List</h5>
                <Button
                    className="text-white btn-primary btn-lg d-flex align-items-center"
                    onClick={() => setModalShow(true)}
                >
                    Add Underwriter
                </Button>
            </div>
            <TableComponent
                title=""
                table_fields={tableFields}
                table_data={underwriterData}
                row_data={tableRowData}
                pageSize={10}
            />
            
            </div>

            <AddProductUnderwriter fetchUnderwriters={refetch} show={modalShow} onHide={modalClose} />
        </div>
    );

    // Commented out previous unused code for clean UI
    /*
    const intermediary = {
        name: 'Ianlam',
        email: 'kk@ymcu, ITT@gmcu',
        status: 'active',
        paypal: 'aa-32',
        premium: { total: 5000000, settled: 4000000, pending: 1000000 },
        commission: { total: 2000000, settlement: 1000000, pending: 1000000, settled: 500000 },
        policy: { number: 20, volume: 10000000 },
        producer: { motor: 3, domestic: 7 }
    };

    return (
        <div className="container mt-4">
            <h1 className="mb-4">My Underwriter</h1>

            <Button
                className="text-white btn-blue rounded #float-right mb-3"
                onClick={() => setModalShow(true)}
            >
                Add Underwriter
            </Button>

            <AddProductUnderwriter fetchUnderwriters={refetch} show={modalShow} onHide={modalClose} />
            <Card className="mb-4">
                <Card.Header as="h5">Underwriter Details</Card.Header>
                <Card.Body>
                    <Card.Text>
                        <p><strong>Name:</strong> {intermediary.name}</p>
                        <p><strong>Email:</strong> {intermediary.email}</p>
                        <p><strong>Status:</strong> {intermediary.status}</p>
                        <p><strong>Paypal:</strong> {intermediary.paypal}</p>
                    </Card.Text>
                </Card.Body>
            </Card>

            <Row>
                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Header as="h5">Premium Summary</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <p><strong>Total:</strong> {intermediary.premium.total}</p>
                                <p><strong>Settled:</strong> {intermediary.premium.settled}</p>
                                <p><strong>Pending:</strong> {intermediary.premium.pending}</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Header as="h5">Commission Summary</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <p><strong>Total:</strong> {intermediary.commission.total}</p>
                                <p><strong>Settlement:</strong> {intermediary.commission.settlement}</p>
                                <p><strong>Pending:</strong> {intermediary.commission.pending}</p>
                                <p><strong>Settled:</strong> {intermediary.commission.settled}</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Header as="h5">Policy Details</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <p><strong>Number:</strong> {intermediary.policy.number}</p>
                                <p><strong>Volume:</strong> {intermediary.policy.volume}</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Header as="h5">Product Details</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <p><strong>Motor:</strong> {intermediary.producer.motor}</p>
                                <p><strong>Domestic:</strong> {intermediary.producer.domestic}</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
    */
}

export default Underwriter;